const ONE_MINUTE = 60000;

export default class GeoLocationService {
    constructor() {
        this.maxAge = ONE_MINUTE * 60;
    }

    fetchLocation() {
        let self = this;
        return new Promise((resolve, reject) => {
            let location;
            // if we are at dev and exits cookie for override loc
            if (CBS.AppMode === 'dev') {
                location = self.__getFromCookie();
                if (location !== null) {
                    resolve(location);
                    return;
                }
            }
            // if we already have location in cache, then gtfo
            location = self.__getFromCache();
            if (location !== null) {
                resolve(location);
                return;
            }

            // otherwise try to fetch location
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    function (location) {
                        if (
                            location &&
                            location.coords &&
                            location.coords.latitude &&
                            location.coords.longitude
                        ) {
                            let locationObj = self._parseLocationObj(location);
                            self.__saveToCache(locationObj);
                            resolve(locationObj);
                        } else {
                            self.__fallback(resolve, reject);
                        }
                    },
                    function () {
                        self.__fallback(resolve, reject);
                    },
                    { timeout: 10000, maximumAge: self.maxAge, enableHighAccuracy: false }
                );
            }
        });
    }

    __getFromCookie() {
        let cookiename = 'latlon';
        let match = document.cookie.match(new RegExp('(^| )' + cookiename + '=([^;]+)'));
        if (match) {
            let coords = decodeURIComponent(match[2]).split(',');
            return {
                coords: {
                    latitude: coords[0],
                    longitude: coords[1]
                }
            };
        } else {
            return null;
        }
    }

    _parseLocationObj(raw) {
        let lat = +(raw.coords ? raw.coords.latitude : raw.location.lat);
        let lng = +(raw.coords ? raw.coords.longitude : raw.location.lng);
        return {
            coords: {
                latitude: lat.toFixed(2),
                longitude: lng.toFixed(2)
            }
        };
    }

    /**
     * @param posObj
     * @private
     */
    __saveToCache(posObj) {
        let cache = {
            pos: posObj,
            expires: new Date().getTime() + this.maxAge
        };

        window.sessionStorage.setItem('geo_cache', JSON.stringify(cache));
    }

    /**
     * @returns {null|*}
     * @private
     */
    __getFromCache() {
        let cache = window.sessionStorage.getItem('geo_cache');
        if (cache) {
            let cacheObj = JSON.parse(cache);
            if (cacheObj && cacheObj.pos && cacheObj.expires > new Date().getTime()) {
                return cacheObj.pos;
            }
        }

        return null;
    }

    /**
     * If browser location detection not supports
     * @private
     */
    __fallback(resolve, reject) {
        if (!!CBS.Registry.Features?.geo_location_google_api) {
            this.__fetchLatLngWithGoogleApi(resolve, reject);
            return;
        }

        this.__fetchLatLngWithMaxmind(resolve, reject);
    }

    __fetchLatLngWithGoogleApi(resolve, reject) {
        let self = this;

        $.post(
            'https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBHfXqKCjfVvt8hBsZ36kZTWEr6sr0SFuA',
            function (resp) {
                if (resp && resp.location && resp.location.lat && resp.location.lng) {
                    let locationObj = self._parseLocationObj(resp);
                    self.__saveToCache(locationObj);
                    resolve(locationObj);
                } else {
                    reject();
                }
            },
            'json'
        ).fail(function () {});
    }

    __fetchLatLngWithMaxmind(resolve, reject) {
        if (CBS.Registry.defaultGeolocation && (!CBS.Registry.geoLoc?.lat || CBS.Registry.geoLoc?.lng)) {
            const locationObj = this._parseLocationObj({
                location: {
                    lat: 40.7128,
                    lng: -74.0060
                }
            });
            resolve(locationObj);
            return;
        }
        else if(!CBS.Registry.geoLoc?.lat || !CBS.Registry.geoLoc?.lng) {
            reject();
            return;
        }

        const locationObj = this._parseLocationObj({
            location: {
                ...CBS.Registry.geoLoc
            }
        });

        resolve(locationObj);
    }
}
